import { useState } from "react";
import { faqs } from "@/mocks/faq";
import type { FaqItem } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

const data = faqs as FaqItem[];

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(data[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-4xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="常见问题"
          title="关于本站与找片的常见疑问"
          desc="把大家最常问的几个问题整理在这里，看完还有疑问也不影响你直接用搜索和筛选去找片子。"
          align="center"
        />

        <div className="flex flex-col gap-3">
          {data.map((item) => {
            const open = openId === item.id;
            return (
              <div
                key={item.id}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? "border-primary-300 bg-background-100/70" : "border-background-200/70 bg-background-50"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => toggle(item.id)}
                    aria-expanded={open}
                    aria-controls={`faq-panel-${item.id}`}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="flex items-center gap-3 text-sm font-medium text-foreground-900 md:text-base">
                      <i className="ri-question-line text-primary-600"></i>
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                        open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                      }`}
                    ></i>
                  </button>
                </h3>
                {open && (
                  <div id={`faq-panel-${item.id}`} className="px-5 pb-5 pl-12">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}